import React, { useEffect } from 'react';
import { addClass } from 'utils/index';
import chrome from 'images/browser-icons/chrome.png';
import safari from 'images/browser-icons/safari.png';
import firefox from 'images/browser-icons/firefox.png';
import opera from 'images/browser-icons/opera.png';
import styles from './style.scss'; //NOSONAR
import Footer from 'components/Cart/Footer'

const BrowserUpdate = () => {
    useEffect(() => {
        addClass(document.body, 'browser-outdate');
    }, [])

    return (
        <>
            <div className={'default-header'}>
                <a href={'/'} className={'jumbo-icon-logo'}></a>
            </div>
            <div className={'browser-update-wrap'}>
                <div className={'browser-update'}>
                    <div className={'browser-update-head'}>
                        <h1>Actualiza tu navegador</h1>
                        <p><strong>Para ingresar a Jumbo.cl</strong>, descarga uno de los siguientes navegadores:</p>

                        <div className={'browers-wrap'}>
                            <a href={'https://www.google.com/chrome'} className={'browser-icon'} target="_blank" rel="noopener noreferrer">
                                <img src={chrome} width="100%" alt='chrome'/>
                                <span>Chrome</span>
                            </a>
                            <a href={'https://support.apple.com/HT204416'} className={'browser-icon'} target="_blank" rel="noopener noreferrer">
                                <img src={safari} width="100%" alt='safari'/>
                                <span>Safari</span>
                            </a>
                            <a href={'https://opera.com'} className={'browser-icon'} target="_blank" rel="noopener noreferrer">
                                <img src={opera} width="100%" alt='opera'/>
                                <span>Opera</span>
                            </a>
                            <a href={'https://www.mozilla.org/es-ES/firefox/new/'} className={'browser-icon'} target="_blank" rel="noopener noreferrer">
                                <img src={firefox} width="100%" alt='firebox'/>
                                <span>Firefox</span>
                            </a>
                        </div>

                    </div>
                    <div className={'browser-update-why'}>
                        <h3>¿Cuáles son los beneficios?</h3>
                        <ul className={'browser-update-items'}>
                            <li>
                                <strong>Seguridad</strong>
                                <p>Un navegador actualizado te protege contra virus, fraudes y otras amenazas.</p>
                            </li>
                            <li>
                                <strong>Velocidad</strong>
                                <p>Tendrás un óptimo rendimiento en tu dispositivo.</p>
                            </li>
                            <li>
                                <strong>Comodidad</strong>
                                <p>Más personalización en tu experiencia web.</p>
                            </li>
                            <li>
                                <strong>Nuevas tecnologías</strong>
                                <p>Sitios con tecnologías recientes se desplegarán correctamente.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default BrowserUpdate;
